// extracted by mini-css-extract-plugin
module.exports = {"form":"GenericPreload_form__jw5dt","recaptcha":"GenericPreload_recaptcha__1cKGx"};